import { useSupplierAuthentication } from "./useSupplierAuthentication";
import { useNavbarManagement } from "./useNavbarManagement";
import { useEffect } from "react";
import { useSupplierData } from "./useSupplierData";
import { useLocation } from "react-router-dom";
import { isFreeFeature } from "layout/utils/SupplierContainer/routes";
import { clearTokenCookies } from "lib/auth/authService";
import { useErrorMessage } from "./useErrorMessage";

interface UseLayoutAccessProps {
    secureId: string;
    token: string;
}

export const useLayoutAccess = ({ secureId, token }: UseLayoutAccessProps) => {
    const location = useLocation();

    const { isAuthenticated, navigateToExternalHomePage } =
        useSupplierAuthentication(token);

    const {
        supplierName,
        selectedSupplierId,
        error,
        bookingList,
        farmerImage,
        farmerName
    } = useSupplierData(secureId, location.pathname, isAuthenticated || false);

    const { currentNavbarSections, adjustNavbarListLeadDetails } =
        useNavbarManagement();



    return {
        isAuthenticated,
        supplierName,
        selectedSupplierId,
        currentNavbarSections,
        bookingList,
        farmerName,
        farmerImage
    };
};
